export default __webpack_public_path__ + "static/media/055-online-payment.93f50c04.svg";